var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Paragraph } from '../paragraph';
import { descriptionStyle } from './styles';
function Description(_a) {
    var inverted = _a.inverted, size = _a.size, children = _a.children;
    return (_jsx(Paragraph, __assign({ css: descriptionStyle({ size: size }), inverted: inverted }, { children: children })));
}
export default Description;
